<template>
  <z-dialogo ref="dialogo" titulo="Imprimir vendas do dia" :dividers="true" largura="900px" persistent>

    <template #texto>
      <v-form v-model="form_valido" ref="form" lazy-validation>
        <v-row dense>
          <v-col cols="3">
            <z-date-picker-menu
              v-model="filtro.data"
              placeholder=" "
              label="Data"
              filled
              dense
              hide-details
              :rules="[regras.data]"
            ></z-date-picker-menu>
          </v-col>
          <v-col cols="6">
            <v-autocomplete 
              v-model="filtro.vendedor_id"
              :items="vendedores" 
              clearable
              filled
              dense
              label="Vendedor"
              @click:clear="filtro.vendedor_id = ''"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <z-select 
              v-model="filtro.terminal"
              :items="terminais" 
              label="Terminal"
              placeholder=" "
              clearable
              @click:clear="filtro.terminal = ''"
            ></z-select>
          </v-col>

        </v-row>
      </v-form>
    </template>


    <template #actions_right>
      <v-btn text @click="$refs.dialogo.fechar()" :disabled="loading">
        Cancelar
      </v-btn>
      <v-btn depressed color="primary" @click="imprimir" :loading="loading" :disabled="!form_valido">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script>
// import { MESES } from '@/app/globals';
import { hoje, gerarTerminais } from '@/app/helpers/utils';
export default {
  name: 'PedidosDiario',

  props: {
    relatorio: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
},

  data() {
    return {
        aberto: false,
        filtro: {
          vendedor_id: '',
          data: hoje(),
          terminal: '',
        },
        meses: this.$globals.MESES,
        vendedores: [],
        form_valido: true,

        regras: {
          data: v => !!v || 'Data é obrigatória',
          vendedor_id: v => !!v || 'Vendedor é obrigatório',
          terminal: v => !!v || 'Terminal é obrigatório',
        },
    }
  },

  computed: {
    anos() {
      let anos = [];
      for (let ano = 2015; ano <= this.$dayjs().format('YYYY'); ano++) {
        anos.push(ano.toString());
      }
      return anos.reverse();
    },

    terminais() {
      return gerarTerminais();
    },
  },

  methods: {
    async abrir() {
      await this.$store.dispatch("listas/vendedores");
      this.vendedores = this.$store.getters["listas/vendedores"];
      // this.resetFiltro();
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    resetFiltro() {
      this.filtro = {
        vendedor_id: '',
        data: hoje(),
        terminal: '',
      };
    },

    imprimir() {
      if (!this.$refs.form.validate()) return;

      this.$emit('imprimir', this.filtro);
    },
  },
};
</script>

<style scoped></style>
